// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2bd6f","description":"PatientConsentPreview_description__iGqN2"};